import { cx } from "utils";


interface LimitedOfferRibbonProps {
  text: string;
  className?: string;
}

export default function LimitedOfferRibbon({
  text,
  className,
}: LimitedOfferRibbonProps) {
  return (
    <div
      className={cx(
        "flex h-6 items-center justify-center px-2.5 overflow-hidden bg-[#fed35b] shadow-[0_2px_4px_0_rgba(0,0,0,0.12)]",
        className
      )}
    >
      <p className="font-['Inter',sans-serif] font-bold text-[10px] leading-normal text-center uppercase tracking-[0.4px] text-[#1c170a] whitespace-nowrap">
        {text}
      </p>
    </div>
  );
}
